import { get, patch } from 'utils/fetch';
import endpoints, { EEndpoints } from 'config/endpoints';
import { pendingTasks as types } from 'types';

const pendingTasks = {
    get() {
        return get<types.TPendingTasks[]>(
            `${endpoints[EEndpoints.pendingTasksGet]()}`,
        );
    },
    approve({ id }: types.TApprovePendingTasksParams) {
        return patch<types.TPendingTasks, null>(
            `${endpoints[EEndpoints.pendingTasksApprove](id)}`,
            {},
        );
    },
    reject({ id, reason }: types.TRejectPendingTasksParams) {
        return patch<types.TPendingTasks, null>(
            `${endpoints[EEndpoints.pendingTasksReject](id)}`,
            {
                reason,
            },
        );
    },
};

export default pendingTasks;
